class AccessibilityShim {
  constructor() {
    this.skipIssuuIframe()
    this.processExternalLinks()
    this.processFileLinks()
    this.removeIconTextWhenCopied()
  }

  skipIssuuIframe() {
    document.querySelectorAll(".issuu-block__embed--iframe").forEach(block => {
      const iframe = block.querySelector("iframe")
      if (iframe) {
        iframe.setAttribute("tabindex", -1)
        iframe.setAttribute("aria-hidden", "true")
      }
    })
  }

  processExternalLinks() {
    const links = [
      ...document.querySelectorAll(".typography a[href]"),
      ...document.querySelectorAll("a[href].link-container"),
    ]
    const currentHost = window.location.host

    links.forEach(link => {
      if (link.host !== currentHost && !link.classList.contains("btn") && !link.classList.contains("external-link")) {
        link.classList.add("external-link")
        link.appendChild(this.createIconElement("material-icons", "open_in_new"))
      }
    })
  }

  processFileLinks() {
    const fileLinks = {
      pdf: {
        selectors: ['[href$=".pdf"]', '[href$=".PDF"]', ".pdf"],
        icon: {
          classes: ["material-icons"],
          text: "picture_as_pdf",
        },
      },
      txt: {
        selectors: ['[href$=".txt"]', '[href$=".TXT"]', ".txt"],
        icon: {
          classes: ["material-icons"],
          text: "library_books",
        },
      },
      ppt: {
        selectors: ['[href$=".ppt"]', '[href$=".PPT"]', '[href$=".pptx"]', '[href$=".PPTX"]', ".ppt"],
        icon: {
          classes: ["material-icons"],
          text: "library_books",
        },
      },
      doc: {
        selectors: [
          '[href$=".doc"]',
          '[href$=".DOC"]',
          '[href$=".docx"]',
          '[href$=".DOCX"]',
          '[href$=".rtf"]',
          '[href$=".RTF"]',
          ".doc",
        ],
        icon: {
          classes: ["gwrc-icons", "icon-word"],
        },
      },
      xls: {
        selectors: ['[href$=".xls"]', '[href$=".XLS"]', '[href$=".xlsx"]', '[href$=".XLSX"]', ".xls"],
        icon: {
          classes: ["gwrc-icons", "icon-excel"],
        },
      },
      archive: {
        selectors: [
          '[href$=".gz"]',
          '[href$=".GZ"]',
          '[href$=".gzip"]',
          '[href$=".GZIP"]',
          '[href$=".zip"]',
          '[href$=".ZIP"]',
          ".archive",
        ],
        icon: {
          classes: ["material-icons"],
          text: "library_books",
        },
      },
    }

    for (const fileLink in fileLinks) {
      fileLinks[fileLink].selectors.forEach(selector => {
        const links = document.querySelectorAll(`a${selector}`)

        if (links.length) {
          links.forEach(link => {
            if (!link.classList.contains("btn") && !link.classList.contains("content-tile__link")) {
              const icon = this.createIconElement(
                fileLinks[fileLink].icon.classes,
                fileLinks[fileLink].icon.text || null
              )

              link.prepend(icon)
            }
          })
        }
      })
    }
  }

  createIconElement(classes, textContent = null) {
    const icon = document.createElement("span")

    if (Array.isArray(classes)) {
      classes.forEach(name => {
        icon.classList.add(name)
      })
    } else {
      icon.classList.add(classes)
    }

    if (textContent) {
      icon.textContent = textContent
    }

    icon.setAttribute("role", "img")
    icon.setAttribute("aria-label", "Opens in new tab")

    return icon
  }

  async getNewCopyData(text) {
    const clipboardItems = await Promise.all(
      text.map(async function(item) {
        const htmlBlob = await item.getType("text/html")

        if (htmlBlob) {
          const htmlContent = await htmlBlob.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(htmlContent, "text/html")
          const anchors = doc.querySelectorAll("a")

          if (anchors.length > 0) {
            anchors.forEach(function(anchor) {
              const copy = anchor.cloneNode(true)
              const icons = copy.querySelectorAll("i")
              icons.forEach(icon => icon.remove())

              anchor.parentNode.replaceChild(copy, anchor)
            })

            const newHtml = doc.documentElement.outerHTML
            const newTextContent = doc.documentElement.textContent

            const clipboardData = {
              "text/plain": new Blob([newTextContent], { type: "text/plain" }),
              "text/html": new Blob([newHtml], { type: "text/html" }),
            }

            return new window.ClipboardItem(clipboardData)
          }
        }
      })
    )

    return clipboardItems.filter(item => item !== undefined)
  }

  async removeIconTextWhenCopied() {
    document.addEventListener("copy", async evt => {
      try {
        const htmlText = await navigator.clipboard.read()
        const clipboardItems = await this.getNewCopyData(htmlText)

        if (clipboardItems.length > 0) {
          await navigator.clipboard
            .write(clipboardItems)
            .then(() => {
              //
            })
            .catch(function(error) {
              // eslint-disable-next-line no-console
              console.error("Unable to write to clipboard. Error:")
              // eslint-disable-next-line no-console
              console.log(error)
            })
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Unable to read from clipboard. Error:")
        // eslint-disable-next-line no-console
        console.log(error)
      }

      evt.preventDefault()
    })
  }
}

export default function init() {
  new AccessibilityShim()
}
